import { US_STATES } from "../constants";
import { INPUT_STYLE, LABEL_STYLE } from "../styles/shared.js";

export default function ContactForm({ contact, onContactChange, errors }) {
  var field = function(key, label, placeholder, opts) {
    opts = opts || {};
    var hasError = errors[key];
    return (
      <div style={{ marginBottom: "12px", ...opts.wrapStyle }}>
        <label style={LABEL_STYLE}>{label}{opts.optional ? "" : " *"}</label>
        <input
          value={contact[key]}
          onChange={function(e) { onContactChange(key, e.target.value); }}
          placeholder={placeholder}
          style={{ ...INPUT_STYLE, ...(hasError ? { borderColor: "#D32F2F" } : {}) }}
        />
        {hasError && <div style={{ fontSize: "11px", color: "#D32F2F", marginTop: "3px" }}>{errors[key]}</div>}
      </div>
    );
  };

  return (
    <div>
      <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", margin: "0 0 4px", color: "#1A1A1A", fontWeight: 800 }}>
        Your Information
      </h2>
      <p style={{ fontSize: "13px", color: "#888", margin: "0 0 20px" }}>
        We'll use this to process your donation and deliver your yard sign.
      </p>
      <div style={{ display: "flex", gap: "10px" }}>
        {field("firstName", "First Name", "Jane", { wrapStyle: { flex: 1 } })}
        {field("lastName", "Last Name", "Smith", { wrapStyle: { flex: 1 } })}
      </div>
      {field("email", "Email", "jane@example.com")}
      {field("phone", "Phone", "(404) 555-1234", { optional: true })}
      {field("address", "Address", "123 Main St")}
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        {field("city", "City", "Decatur", { wrapStyle: { flex: "2 1 120px" } })}
        <div style={{ marginBottom: "12px", flex: "1 1 80px" }}>
          <label style={LABEL_STYLE}>State *</label>
          <select
            value={contact.state}
            onChange={function(e) { onContactChange("state", e.target.value); }}
            style={{ ...INPUT_STYLE, background: "#fff", cursor: "pointer", ...(errors.state ? { borderColor: "#D32F2F" } : {}) }}
          >
            <option value="">--</option>
            {US_STATES.map(function(s) { return <option key={s} value={s}>{s}</option>; })}
          </select>
          {errors.state && <div style={{ fontSize: "11px", color: "#D32F2F", marginTop: "3px" }}>{errors.state}</div>}
        </div>
        {field("zip", "ZIP Code", "30030", { wrapStyle: { flex: "1 1 80px" } })}
      </div>
    </div>
  );
}
